import { Field } from 'ngx-angular-query-builder';
import { FilterOperators, FieldMetadataCollection, FilterFieldProvider } from '@common/filter/filtering';
import { WidgetConfiguration } from '@feature/widget-configs';

export class AdminInvoiceAndReceiptsWidgetFilterFieldProvider implements FilterFieldProvider {

  private readonly fieldMetaDataCollection = new FieldMetadataCollection();

  constructor(widgetConfig: WidgetConfiguration) {

    const addFilter = (label: string,
      optionsName: string,
      type: string,
      ops: string[]) => this.fieldMetaDataCollection.addFilter(label, optionsName, type, ops);

    addFilter('Date', 'SystemInvoiceDate', 'date', FilterOperators.AdminDateDefaults);
    addFilter('Document Ref', 'SystemInvoiceRef', 'string', FilterOperators.AdminStringDefaults);
    addFilter('Description', 'SystemInvoiceStyle', 'string', FilterOperators.AdminStringDefaults);
    addFilter('Amount', 'SystemNetAmount', 'number', FilterOperators.AdminScalar);
  }

  getFilterFields(): Array<Field> {
    return this.fieldMetaDataCollection.getFilterFields();
  }

  getFieldNameFromLabel(label: string): string {
    return this.fieldMetaDataCollection.getFieldNameFromLabel(label);
  }

  getFilterField(fieldName: string): Field {
    return this.fieldMetaDataCollection.getFilterField(fieldName);
  }
}
